import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { OverlayScrollbarsComponent } from 'overlayscrollbars-react';

const BriefText = ({ project = {} }) => {
    return (
        <OverlayScrollbarsComponent element="div" className="briefText" options={{ scrollbars: { autoHide: 'never' } }} defer>
            <ReactMarkdown remarkPlugins={[remarkGfm]}>
                {project.brief || ''}
            </ReactMarkdown>
        </OverlayScrollbarsComponent>
    );
};

export default BriefText;
